import {
  u2000CurrentWeekMondayYmd,
  u2000FormatYmdFromParts,
  u2000MondayOfCivilWeekYmd,
  u2000ShiftCivilYmd,
} from '../../u2000Core/tools/U2000DateTimeHelpers';
import { u3130FormatPeriodDateRange } from '../../u3130TimesheetApproval/tools/u3130FormatPeriodDateRange';

/** Plafond POST /U3129/findAvailablePeriods (aligné U3129FindAvailablePeriodsRequestSchema). */
export const U3129_FIND_AVAILABLE_PERIODS_MAX = 32;

const CREATE_TIMESHEET_PAST_WEEKS = 2;
const CREATE_TIMESHEET_FUTURE_MONTHS = 6;

export type U3129CreateTimesheetPeriodOption = { value: string; label: string };

export type U3129BuildCreateTimesheetPeriodCandidatesOptions = {
  /** Lundi de la semaine courante (tests) ; défaut = lundi org courant. */
  anchorMondayYmd?: string;
};

/** Ajoute `months` mois civils à un jour `yyyy-MM-dd` (arithmétique UTC, sans fuseau navigateur). */
export function u3129AddCivilMonthsYmd(ymd: string, months: number): string | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd.trim());
  if (!m) return null;
  const utcMs = Date.UTC(Number(m[1]), Number(m[2]) - 1 + months, Number(m[3]));
  const d = new Date(utcMs);
  return u2000FormatYmdFromParts({ y: d.getUTCFullYear(), mo: d.getUTCMonth() + 1, d: d.getUTCDate() });
}

function u3129CompareCivilYmd(a: string, b: string): number {
  return a.localeCompare(b);
}

/**
 * Lundis candidats pour le dialogue « Nouvelle feuille de temps » :
 * 2 semaines passées + semaine courante + lundis hebdomadaires jusqu'à 6 mois civils après le lundi courant.
 */
export function u3129BuildCreateTimesheetPeriodCandidates(
  options?: U3129BuildCreateTimesheetPeriodCandidatesOptions,
): U3129CreateTimesheetPeriodOption[] {
  const anchorMonday = options?.anchorMondayYmd?.trim() || u2000CurrentWeekMondayYmd();
  const horizonYmd = u3129AddCivilMonthsYmd(anchorMonday, CREATE_TIMESHEET_FUTURE_MONTHS);
  const lastMonday =
    (horizonYmd ? u2000MondayOfCivilWeekYmd(horizonYmd) : null) ?? anchorMonday;
  const startMonday =
    u2000ShiftCivilYmd(anchorMonday, -CREATE_TIMESHEET_PAST_WEEKS * 7) ?? anchorMonday;

  const optionsOut: U3129CreateTimesheetPeriodOption[] = [];
  const seen = new Set<string>();
  let current: string | null = startMonday;

  while (current && u3129CompareCivilYmd(current, lastMonday) <= 0) {
    const mondayOfWeek = u2000MondayOfCivilWeekYmd(current);
    const value = mondayOfWeek && mondayOfWeek === current ? current : mondayOfWeek ?? current;
    if (!seen.has(value)) {
      seen.add(value);
      optionsOut.push({
        value,
        label: u3130FormatPeriodDateRange(value),
      });
    }
    current = u2000ShiftCivilYmd(current, 7);
  }

  return optionsOut;
}
